import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/Countertop.webp";
import {MdCountertops} from "react-icons/md";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function CountertopInstallationPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Countertop Installation Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert countertop installation services in Charlotte NC. From kitchen to bathroom, our skilled team ensures flawless results tailored to your needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><MdCountertops className={classes.servicesIcon}/> {languageContext.services.CountertopInstallationPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.CountertopInstallationPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.CountertopInstallationPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.CountertopInstallationPage.text2}</span>
                            <br/>
                            {languageContext.services.CountertopInstallationPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.CountertopInstallationPage.text4}</span>
                            <br/>
                            {languageContext.services.CountertopInstallationPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.CountertopInstallationPage.text6}</span>
                            <br/>
                            {languageContext.services.CountertopInstallationPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.CountertopInstallationPage.text8}</span>
                            <br/>
                            {languageContext.services.CountertopInstallationPage.text9}
                            <br/><br/>
                            <span>{languageContext.services.CountertopInstallationPage.text10}</span>
                            <br/>
                            {languageContext.services.CountertopInstallationPage.text11}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.imageHorizontal}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default CountertopInstallationPage;